import { render, staticRenderFns } from "./LbaDragAndDropTwoLists.vue?vue&type=template&id=5bd0960e"
import script from "./LbaDragAndDropTwoLists.vue?vue&type=script&lang=js"
export * from "./LbaDragAndDropTwoLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports